import {
    Grid,
    Heading,
    Skeleton,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import EditGuests from "./edit-guests";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";

/** Mirrors the ToggleButton grid in EditGuests so the buttons don't shift in on arrival. */
function GuestGridSkeleton() {
    return (
        <Grid templateColumns="repeat(4, 1fr)" gap={ThemeSpaceVariable.Small} width="100%">
            {Array.from({ length: 8 }).map((_, index) => (
                <Skeleton key={index} height={ThemeSpaceVariable.XLarge} w="full" />
            ))}
        </Grid>
    );
}

interface EditGuestsViewProps {
    guests: number | null;
    setGuests: (guests: number | null) => void;
    availableGuestSizes: number[];
    isLoading?: boolean;
}

const EditGuestsView = ({
    guests,
    setGuests,
    availableGuestSizes,
    isLoading = false,
}: EditGuestsViewProps) => {
    const { t } = useTranslation();

    useStepTracking({
        stepName: TrackingStepName.EditBookingGuests,
    });

    return (
        <Stack spacing={ThemeSpaceVariable.Medium}>
            <Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge}>
                {t("editBooking.chooseNewGuests")}
            </Heading>
            {isLoading ? (
                <GuestGridSkeleton />
            ) : (
                <EditGuests
                    setGuests={setGuests}
                    guests={guests}
                    availableGuestSizes={availableGuestSizes}
                />
            )}
        </Stack>
    );
};

export default EditGuestsView;
